export default __webpack_public_path__ + "static/media/normallogo.4c34d2a0.jpg";